import * as Sentry from "@sentry/vue";
import { identifyTalent, trackNewApplication, trackEvent } from "@/services/posthog";

export function processAuthResponse(store, {
  token,
  user,
  authMeta,
  talent,
  company,
  application_id,
  created_account,
  channel,
  vacancy_id,
  company_label,
}) {
  localStorage.setItem("userToken", token);
  localStorage.setItem("last_login_method", "google");
  store.dispatch("auth/addToken", { token });

  const resolvedTalent = talent || (user && user.talent);
  store.dispatch("auth/addUser", {
    user: {
      ...user,
      ...(authMeta || {}),
      talent: resolvedTalent,
    },
  });
  if (company_label === "anonima") {
    const diversityUser = (resolvedTalent && resolvedTalent.user) || user;
    if (diversityUser) {
      store.dispatch("diversity/addUser", { user: diversityUser });
    }
  }
  store.dispatch("diversity/addDiversity", resolvedTalent);

  if (company && company.id != null) {
    store.dispatch("company/addId", { company });
  }

  if (application_id) {
    sessionStorage.setItem("@recrutei:talent:application_id", application_id);
  }

  const userName = user && user.name;
  const userEmail = user && user.email;
  Sentry.setUser({ username: userName, email: userEmail });
  identifyTalent(userEmail, {
    email: userEmail,
    name: userName,
    last_company_label: company_label,
  });

  if (created_account) {
    trackEvent("signed_up_google", {});
  }

  trackEvent("logged_account", { channel });

  if (application_id) {
    trackNewApplication({
      vacancy_id: vacancy_id || undefined,
      company_id: company && company.id,
      company_name: company && company.name,
      company_label: company_label || (company && company.label),
      channel,
    });
  }
}
